import OrderTypeRow from "./BrandRow";
import "../../styles/table.css";

export default function OrderTypeTable({ ordertypes, onEdit, onDelete }) {
  return (
    <div className="tableCard">
      <table className="modernTable">
        <thead>
          <tr>
            <th>Type de commande</th>
            <th>Description</th>
          
          </tr>
        </thead>

        <tbody>
          {ordertypes.map((ordertype) => (
            <OrderTypeRow
              key={ordertype.id}
              ordertype={ordertype}
              onEdit={onEdit}
              onDelete={onDelete}
          
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
